import { createApp } from 'vue';
import WhosInvolvedApp from './vue-components/WhosInvolvedApp.vue'

import FloatingVue from 'floating-vue';



const appElement = document.getElementById('whos-involved-app');
const orgs = []
// console.log(logos );

const app = createApp({
    components: {
        WhosInvolvedApp
    },
    data() {
        return {
            orgs
        };
    }
});


app.use(FloatingVue);
app.mount('#whos-involved-app');